export const userflowConstants = {
  token: (PINS_ENV === 'qa') ? 'ct_ezscv53kxbckhoogufhdbmpwci' : 'ct_npiw6ybynrawtax5c6sjcu4xeq'
};
